/** VR Porn Base's 100 biggest studios (its "categories", 405 in all, read from its WordPress API on 2026-10-26, most posts first). A studio
 * page is /category/{slug}/ and pages as /category/{slug}/page/N/. */
export const VRPORNBASE_STUDIOS = [
  { slug: "virtual-taboo", label: "Virtual Taboo" },
  { slug: "pervrt", label: "perVRt" },
  { slug: "wankitnowvr", label: "WankitNowVR" },
  { slug: "virtual-real-porn", label: "Virtual Real Porn" },
  { slug: "wankzvr", label: "WankzVR" },
  { slug: "badoink-vr", label: "Badoink VR" },
  { slug: "naughty-america", label: "Naughty America VR" },
  { slug: "jav", label: "JAV" },
  { slug: "zexyvr", label: "ZexyVR" },
  { slug: "czech-vr", label: "Czech VR" },
  { slug: "teen-mega-world", label: "TmwVRnet" },
  { slug: "vr-bangers", label: "VR Bangers" },
  { slug: "transexual-vr-porn", label: "Transsexual VR Porn" },
  { slug: "realjamvr", label: "RealJamVR" },
  { slug: "vr-hush", label: "VR Hush" },
  { slug: "lethalhardcorevr", label: "LethalHardcoreVR" },
  { slug: "lustreality", label: "LustReality" },
  { slug: "vrsexperts", label: "VRSexperts" },
  { slug: "czech-vr-fetish", label: "Czech VR Fetish" },
  { slug: "vr-allure", label: "VR Allure" },
  { slug: "vrcosplayx", label: "VRCosplayX" },
  { slug: "baberoticavr", label: "BaberoticaVR" },
  { slug: "no2studiovr", label: "No2StudioVR" },
  { slug: "stockingsvr", label: "StockingsVR" },
  { slug: "sinsvr", label: "SinsVR" },
  { slug: "vredging", label: "VRedging" },
  { slug: "vrgoddess", label: "VRGoddess" },
  { slug: "milfvr", label: "MilfVR" },
  { slug: "realitylovers", label: "RealityLovers" },
  { slug: "18vr", label: "18VR" },
  { slug: "stasyq-vr", label: "StasyQ VR" },
  { slug: "jimmydrawsvr", label: "JimmyDrawsVR" },
  { slug: "squeeze-vr", label: "Squeeze VR" },
  { slug: "vrlatina", label: "VRLatina" },
  { slug: "onlytease", label: "OnlyTease" },
  { slug: "sexyvr", label: "SexyVR" },
  { slug: "stripzvr", label: "StripzVR" },
  { slug: "fuckpassvr", label: "FuckPassVR" },
  { slug: "vrpornjack", label: "VRPornJack" },
  { slug: "vrfootfetish", label: "VRFootFetish" },
  { slug: "tadpolexxxstudio", label: "TadPoleXXXStudio" },
  { slug: "pspornvr", label: "PSPornVR" },
  { slug: "vrixxens", label: "VRixxens" },
  { slug: "vrconk", label: "VRConk" },
  { slug: "vroomed", label: "VRoomed" },
  { slug: "realhotvr", label: "RealHotVR" },
  { slug: "feelmevr", label: "FeelmeVR" },
  { slug: "dark-room-vr", label: "Dark Room VR" },
  { slug: "suck-me-vr", label: "Suck Me VR" },
  { slug: "vr-pornnow", label: "VR pornnow" },
  { slug: "33", label: "+33" },
  { slug: "blusherotica", label: "BlushErotica" },
  { slug: "povr-originals", label: "POVR Originals" },
  { slug: "deviantsvr", label: "DeviantsVR" },
  { slug: "tommystone", label: "AsianSexVR" },
  { slug: "immoral-family", label: "Immoral Family" },
  { slug: "amateur-couples-vr", label: "Amateur Couples VR" },
  { slug: "peeping-thom", label: "Peeping Thom" },
  { slug: "plushies-tv", label: "Plushies TV" },
  { slug: "jackandjill", label: "JackandJill" },
  { slug: "deepinsex", label: "Deepinsex" },
  { slug: "vrxclouds", label: "VRXClouds" },
  { slug: "vrstars", label: "VRStars" },
  { slug: "virtual-papi", label: "Virtual Papi" },
  { slug: "povcentralvr", label: "POVcentralVR" },
  { slug: "gay-vr-porn", label: "Gay VR Porn" },
  { slug: "groobyvr", label: "GroobyVR" },
  { slug: "czech-vr-casting", label: "Czech VR Casting" },
  { slug: "vrsolos", label: "VRsolos" },
  { slug: "eagle", label: "Eagle" },
  { slug: "virtualxporn", label: "VirtualXPorn" },
  { slug: "erotic-sinners", label: "Erotic Sinners" },
  { slug: "steel-fantasy", label: "Steel Fantasy" },
  { slug: "istripper", label: "iStripper" },
  { slug: "taboo-vr-porn", label: "Taboo VR Porn" },
  { slug: "virtualrealgay", label: "VirtualRealGay" },
  { slug: "blowvr", label: "BlowVR" },
  { slug: "kinkvr", label: "KinkVR" },
  { slug: "strictlyglamourvr", label: "StrictlyGlamourVR" },
  { slug: "virtualrealtrans", label: "VirtualRealTrans" },
  { slug: "dreamcam", label: "Dreamcam" },
  { slug: "hologirlsvr", label: "HoloGirlsVR" },
  { slug: "glosstightsglamourvr", label: "GlossTightsGlamourVR" },
  { slug: "vrhard", label: "VRHARD" },
  { slug: "sabdeluxe-vr", label: "Sabdeluxe VR" },
  { slug: "vr-queens", label: "VR Queens" },
  { slug: "blondehexe", label: "BlondeHexe" },
  { slug: "virtualrealpassion", label: "VirtualRealPassion" },
  { slug: "amateurvr3d", label: "AmateurVR3D" },
  { slug: "wetvr", label: "WetVR" },
  { slug: "porncornvr", label: "PornCornVR" },
  { slug: "vrhotwife", label: "VRHotwife" },
  { slug: "3d-pickup", label: "3D Pickup" },
  { slug: "bangbrosvr", label: "BangBros VR" },
  { slug: "catalina-cruz-vr", label: "Catalina Cruz VR" },
  { slug: "miss-lexa", label: "Miss Lexa" },
  { slug: "glamour-vr", label: "Glamour-VR" },
  { slug: "fbombstudioz", label: "FBOMB STUDIOZ" },
  { slug: "vrb-trans", label: "VRB Trans" },
  { slug: "vrmassaged", label: "VRMassaged" },
] as const
